import { useContext } from 'react'
import DialogStackContext from './DialogStackContext'
import type { DialogStackContextValue } from './DialogStackContext'

type BaseDialogStackContextValue = Omit<DialogStackContextValue, 'crmContext' | 'setCrmContext'>

export function useDialogs(): BaseDialogStackContextValue {
  // eslint-disable-next-line
  const { crmContext, setCrmContext, ...rest } = useContext(DialogStackContext)
  return rest
}

export default useDialogs
